<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Suspend voucher'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="form" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'I want to suspend voucher'|translate}} "{{voucher.name}}" {{'for provided quantity of days.'|translate}}</mat-label>
                    <input name="dats" formControlName="days" matInput required>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Cancel">
            {{'Cancel'|translate}}
        </button>
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Save">
            {{'Suspend'|translate}}
        </button>

    </div>
</div>
